export const priceToDecimal = (price: number): number => {
  return +(price / 100).toFixed(2);
};
